export function IconParrot() {
  return (
    <svg
      width="293"
      height="397"
      viewBox="0 0 293 397"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <g clipPath="url(#clip1)">
          <g filter="url(#filter0_i)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M96.5251 126.762L-133.973 103.45L-244.7 400.098H80.8857C80.8857 400.098 65.2462 347.65 65.2462 275.468C65.2462 203.286 96.5251 126.762 96.5251 126.762Z"
              fill="#0E0019"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-46.4427 76.9087C-12.354 56.0313 28.8628 43.8227 73.2598 43.8227C190.615 43.8227 285.75 129.126 285.75 234.353C285.75 235.819 285.732 237.282 285.695 238.741H-46.4427V76.9087Z"
            fill="#F65F38"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-54.1676 72.5811V246.466H293.228L293.417 238.935C293.456 237.412 293.475 235.884 293.475 234.353C293.475 124.088 194.067 36.0977 73.2599 36.0977C27.4431 36.0977 -15.1706 48.6978 -50.4772 70.321L-54.1676 72.5811ZM285.695 238.741C285.732 237.282 285.75 235.819 285.75 234.353C285.75 129.126 190.615 43.8227 73.2599 43.8227C28.8629 43.8227 -12.3539 56.0313 -46.4426 76.9087V238.741H285.695Z"
            fill="#09031D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-88.2615 55.6211C-54.8075 36.4699 -14.0911 25.2344 29.8313 25.2344C143.76 25.2344 236.117 100.828 236.117 194.078C236.117 195.7 236.089 197.317 236.034 198.928H-88.2615V55.6211Z"
            fill="#E27B50"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-95.8313 51.2322V206.498H243.347L243.599 199.189C243.658 197.491 243.687 195.787 243.687 194.078C243.687 95.3005 146.452 17.6647 29.8312 17.6647C-15.3723 17.6647 -57.3905 29.2263 -92.0223 49.0517L-95.8313 51.2322ZM236.034 198.928C236.089 197.317 236.117 195.7 236.117 194.078C236.117 100.828 143.76 25.2344 29.8312 25.2344C-14.0912 25.2344 -54.8075 36.4699 -88.2616 55.6211V198.928H236.034Z"
            fill="#09031D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0761 273.078C-67.011 273.078 -139.23 212.048 -139.23 136.764C-139.23 61.4799 -67.011 0.450005 22.0761 0.450005C111.163 0.450005 183.383 61.4799 183.383 136.764C183.383 212.048 111.163 273.078 22.0761 273.078Z"
            fill="#0F001A"
          />
          <path
            opacity="0.210088"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0761 273.078C-67.011 273.078 -139.23 212.048 -139.23 136.764C-139.23 61.4799 -67.011 0.450005 22.0761 0.450005C111.163 0.450005 183.383 61.4799 183.383 136.764C183.383 212.048 111.163 273.078 22.0761 273.078Z"
            fill="#0F001A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60.8517 235.902C0.0326385 235.902 -49.271 194.984 -49.271 144.509C-49.271 94.0346 0.0326385 53.1168 60.8517 53.1168C121.671 53.1168 170.974 94.0346 170.974 144.509C170.974 194.984 121.671 235.902 60.8517 235.902Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-48.8133 152.898C-29.8675 190.204 27.3418 217.313 94.9742 217.313C107.582 217.313 119.828 216.371 131.531 214.597C112.405 227.895 87.7549 235.902 60.8516 235.902C3.44028 235.902 -43.7099 199.441 -48.8133 152.898Z"
            fill="#E9E8E7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M122.953 186.333C115.243 186.333 108.994 180.091 108.994 172.392C108.994 164.692 115.243 158.45 122.953 158.45C130.662 158.45 136.912 164.692 136.912 172.392C136.912 180.091 130.662 186.333 122.953 186.333Z"
            fill="#F5A623"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M101.269 172.392C101.269 184.367 110.986 194.058 122.953 194.058C134.919 194.058 144.637 184.367 144.637 172.392C144.637 160.416 134.919 150.725 122.953 150.725C110.986 150.725 101.269 160.416 101.269 172.392ZM108.994 172.392C108.994 180.091 115.243 186.333 122.953 186.333C130.662 186.333 136.912 180.091 136.912 172.392C136.912 164.692 130.662 158.45 122.953 158.45C115.243 158.45 108.994 164.692 108.994 172.392Z"
            fill="#09031D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M85.1714 127.51H-53.8786V115.118H85.1714V127.51Z"
            fill="#11001E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-28.9582 127.51H-40.8411C-41.3724 125.882 -41.8129 124.224 -42.1579 122.54C-38.0345 124.544 -33.6137 126.217 -28.9582 127.51ZM17.2738 127.51C43.5878 120.201 62.4029 100.767 62.4029 77.9414C62.4029 74.8509 62.0579 71.8227 61.3962 68.8782C78.8672 78.6538 90.3213 95.024 90.3213 113.569C90.3213 118.389 89.5476 123.062 88.0956 127.51H17.2738Z"
            fill="#11001E"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i"
          x="-244.7"
          y="103.45"
          width="341.225"
          height="296.648"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <clipPath id="clip0">
          <rect
            width="293"
            height="397"
            fill="white"
            transform="matrix(-1 2.87868e-08 2.87868e-08 1 293 0)"
          />
        </clipPath>
        <clipPath id="clip1">
          <rect width="515" height="515" fill="white" transform="matrix(-1 0 0 1 363 -118)" />
        </clipPath>
      </defs>
    </svg>
  );
}
